export default "/assets/images/mila-product-white.png?15f480b661e80ecb0fecdc06e01db1f0";